import { reatailmediaApi as baseAPI } from '../api'

export const reportSubPublishersBaseURL = `${baseAPI}/report/network/publishers`
